import { render } from "./LeaveBalanceModal.vue?vue&type=template&id=74d8516c&scoped=true"
import script from "./LeaveBalanceModal.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceModal.vue?vue&type=script&lang=js"

import "./leave-balance-modal.scss?vue&type=style&index=0&id=74d8516c&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d8516c"]])

export default __exports__